"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogSize = void 0;
// eslint-disable-next-line no-shadow
var DialogSize;
(function (DialogSize) {
    DialogSize["X400_Y250"] = "x400y250";
    DialogSize["X450_Y250"] = "x450y250";
    DialogSize["X450_Y350"] = "x450y350";
    DialogSize["X550_Y350"] = "x500y350";
    DialogSize["X550_Y450"] = "x500y450";
    DialogSize["X550_Y500"] = "x550y500";
    DialogSize["X600_Y550"] = "x600y550";
    DialogSize["X800_Y400"] = "x800y400";
    DialogSize["X800_Y550"] = "x800y550";
    DialogSize["X800_Y600"] = "x800y600";
    DialogSize["X800_YFULL"] = "x800yfull";
    DialogSize["X1000_Y500"] = "x1000y500";
    DialogSize["X1000_YFULL"] = "x1000yfull";
    DialogSize["XFULL_YFULL"] = "xfullyfull";
})(DialogSize = exports.DialogSize || (exports.DialogSize = {}));
exports.default = DialogSize;
